import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="employees--sidebar"
export default class extends Controller {
  static targets = ['btn'];

  open() {
    this.element.classList.add('sidebar-opened');
    this.element.classList.remove('sidebar-closed');
  }

  close() {
    this.element.classList.remove('sidebar-opened');
    this.element.classList.add('sidebar-closed');
    this.btnTarget.classList.remove('d-lg-none');
  }
}
